import { useEffect, useState } from "react";
import axios from "axios";
import PhotosManager from "./PhotoManager";
import { TbX, TbHome, TbUsers } from "react-icons/tb";

export default function RoomsDrawer({
  open,
  setOpen,
  room,
  refreshRooms,
  hotelId,
}) {

  const [loading, setLoading] = useState(false);

  const [form, setForm] = useState({
    title: "",
    desc: "",
    maxPeople: 1,
    photos: []
  });

  useEffect(() => {
    if (room) {
      setForm({
        title: room.title || "",
        desc: room.desc || "",
        maxPeople: room.maxPeople || 1,
        photos: room.photos || []
      });
    } else {
      setForm({ title: "", desc: "", maxPeople: 1, photos: [] });
    }
  }, [room, open]);

  const handleSave = async () => {
    if (!form.title || !form.maxPeople) return;

    try {
      setLoading(true);

      if (room) {
        await axios.put(
          `https://api.komorotel.com/api/rooms/${room._id}`,
          form,
          { withCredentials: true }
        );
      } else {
        await axios.post(
          `https://api.komorotel.com/api/rooms/${hotelId}`,
          form,
          { withCredentials: true }
        );
      }

      refreshRooms();
      setOpen(false);

    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 flex justify-end">

      {/* Overlay */}
      <div
        className="absolute inset-0 bg-black/30 backdrop-blur-sm"
        onClick={() => setOpen(false)}
      />

      {/* Drawer */}
      <div className="relative w-full max-w-md bg-white h-full shadow-2xl flex flex-col">

        {/* HEADER */}
        <div className="flex items-center justify-between px-6 py-5 border-b border-gray-100">
          <div>
            <h2 className="text-base font-bold text-gray-900">
              {room ? "Modifier la chambre" : "Nouvelle chambre"}
            </h2>
            <p className="text-xs text-gray-400 mt-0.5">
              {room ? "Modifiez les informations" : "Remplissez les informations de base"}
            </p>
          </div>
          <button
            onClick={() => setOpen(false)}
            className="w-8 h-8 flex items-center justify-center rounded-full hover:bg-gray-100 transition"
          >
            <TbX className="text-gray-500" />
          </button>
        </div>

        {/* CONTENT */}
        <div className="flex-1 overflow-y-auto px-6 py-6 flex flex-col gap-5">

          {/* Nom */}
          <div>
            <label className="text-xs font-semibold text-gray-500 uppercase tracking-wide mb-1.5 block">
              Nom de la chambre *
            </label>
            <div className="relative">
              <TbHome className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" />
              <input
                value={form.title}
                onChange={(e) => setForm({ ...form, title: e.target.value })}
                placeholder="Ex: Chambre Deluxe Vue Mer"
                className="w-full pl-9 pr-4 py-2.5 border border-gray-200 rounded-xl text-sm outline-none focus:border-[var(--k-green)] transition"
              />
            </div>
          </div>

          {/* Description */}
          <div>
            <label className="text-xs font-semibold text-gray-500 uppercase tracking-wide mb-1.5 block">
              Description
            </label>
            <textarea
              value={form.desc}
              onChange={(e) => setForm({ ...form, desc: e.target.value })}
              placeholder="Décrivez la chambre..."
              rows={3}
              className="w-full px-4 py-2.5 border border-gray-200 rounded-xl text-sm outline-none focus:border-[var(--k-green)] transition resize-none"
            />
          </div>

          {/* Capacité */}
          <div>
            <label className="text-xs font-semibold text-gray-500 uppercase tracking-wide mb-1.5 block">
              Capacité maximale *
            </label>
            <div className="relative">
              <TbUsers className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" />
              <input
                type="number"
                min={1}
                value={form.maxPeople}
                onChange={(e) => setForm({ ...form, maxPeople: e.target.value })}
                className="w-full pl-9 pr-4 py-2.5 border border-gray-200 rounded-xl text-sm outline-none focus:border-[var(--k-green)] transition"
              />
            </div>
          </div>

          {/* Photos */}
          <div>
            <label className="text-xs font-semibold text-gray-500 uppercase tracking-wide mb-1.5 block">
              Photos
            </label>
            <PhotosManager
              photos={form.photos}
              setPhotos={(photos) => setForm({ ...form, photos })}
            />
          </div>

        </div>

        {/* FOOTER */}
        <div className="px-6 py-4 border-t border-gray-100">
          <button
            onClick={handleSave}
            disabled={loading || !form.title || !form.maxPeople}
            className={`
              w-full py-2.5 rounded-xl text-sm font-semibold transition
              ${loading || !form.title || !form.maxPeople
                ? "bg-gray-100 text-gray-400 cursor-not-allowed"
                : "bg-[var(--k-green)] text-white hover:bg-[var(--k-green-hover)] active:scale-[0.98]"
              }
            `}
          >
            {loading ? "Enregistrement..." : room ? "Enregistrer" : "Créer la chambre"}
          </button>

          {!room && (
            <p className="text-xs text-center text-gray-400 mt-2">
              Vous pourrez configurer la disponibilité et les tarifs ensuite.
            </p>
          )}

        </div>

      </div>

    </div>
  );
}